import { useWindowHeight, useWindowWidth } from '@react-hook/window-size'
import React, { createContext, FC, useContext, useMemo } from 'react'

import { Device } from './types'

const generateDeviceValue: (height: number, width: number) => Device = (height, width) => {
  if (width > 1024) {
    return {
      height: height,
      width: width,
      pc: true,
      tablet: false,
      mobile: false
    }
  }
  if (width > 769) {
    return {
      height: height,
      width: width,
      pc: false,
      tablet: true,
      mobile: false
    }
  }

  return {
    height: height,
    width: width,
    pc: false,
    tablet: false,
    mobile: true
  }
}

const DeviceContext = createContext<Device>({
  height: null,
  width: null,
  pc: true,
  tablet: false,
  mobile: false
})

const DeviceProvider: FC = ({ children }) => {
  const height = useWindowHeight()
  const width = useWindowWidth()

  const value = useMemo(() => generateDeviceValue(height, width), [width, height])

  return <DeviceContext.Provider value={value}>{children}</DeviceContext.Provider>
}

const useDevice = (): Device => useContext(DeviceContext)

export { DeviceProvider, useDevice }
